import React from "react";
import { useNavigate } from "react-router-dom";

function Essay() {
  const navigate = useNavigate(); // 

  return (
    <section style={styles.container}>
      <h1>Essay Writing Competition</h1>

      <div style={styles.card}>
        <img
          src="https://images.unsplash.com/photo-1455390582262-044cdead277a?w=600&auto=format&fit=crop&q=60"
          alt="essay"
          style={styles.image}
          loading="lazy"
        />
        <h3>Top Winners</h3>

      
        <button style={styles.btn}
          onClick={() => navigate("/winners")}
        >Read Winning Essays
        </button>
      </div>
    </section>
  );
}

const styles = {
  container: {
    padding: "80px 20px",
    textAlign: "center"
  },
  card: {
    marginTop: "30px"
  },
  image: {
    width: "100%",
    maxWidth: "400px",
    borderRadius: "10px"
  },
  btn: {
    marginTop: "20px",
    padding: "10px 20px",
    background: "#19195f",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer" 
  }
};

export default Essay;
